import { render, staticRenderFns } from "./SortOrderDropdown.vue?vue&type=template&id=5fadf38d&"
import script from "./SortOrderDropdown.vue?vue&type=script&lang=js&"
export * from "./SortOrderDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports